import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

const Wrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(54, 52, 51, 0.16);
  z-index: 1;
`

const Overlay = ({ show, className }) => {
  if (!show) {
    return null
  }

  return <Wrapper data-testid="chat-overlay" className={className} />
}

Overlay.propTypes = {
  show: PropTypes.bool.isRequired,
  className: PropTypes.string,
}

export default Overlay
